module["exports"] = [
  "#{first_name}#{last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/name/name.js
// module id = 1856
// module chunks = 0